import * as React from "react";
import * as ReactDOM from "react-dom";

interface IProperties
{
    /**
     * Link zu einem Profilbild.
     */
    profilePicture?: string,

    /**
     * Wird ausgeführt, sobald auf das Item geklickt wird.
     */
    onClick?: (e: MouseEvent) => void
}

export class HeaderProfileItem extends React.Component<IProperties>
{
    /**
     * Standardwerte setzen.
     */
    public static defaultProps: Partial<IProperties> = {
        profilePicture: "/img/profile/no_profile_pic.jpg"
    };

    /**
     * Führt die "onClick" Eigenschaft aus wenn diese gesetzt wurde.
     * @param e Das auslösende Ereignis.
     */
    private onClick = (e: React.MouseEvent<HTMLElement>) =>
    {
        this.props.onClick && this.props.onClick(e.nativeEvent);
    }

    /**
     * Rendert diese Komponente.
     */
    public render(): JSX.Element
    {
        return (
            <div
                className="header_profile-item"
                onClick={this.onClick}>
                <img src={this.props.profilePicture} />
            </div>
        );
    }
}